webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

window.replyPage = 1;

$(function () {
    $('.user_reply').on('focus', function () {
        if ($('.add_reply.edit').length == 0)
            $('.add_reply').addClass('edit');
    });

    $('.user_reply').on('blur', function () {
        if ($('.add_reply.edit').length > 0 && $('.user_reply').val() == '') {
            $('.add_reply.edit').removeClass('edit');
        }
    });

    $('.add_reply').on('click', function () {
        if (!$('input[name=userid]').val()) {
            showLogin();
            return;
        }
    });

    $('.add_reply .btn_pub').on('click', function () {
        if ($('input[name=userid]').val() == '') {
            showLogin();
            return;
        }

        if ($('.user_reply').val() == '') {
            alert('请先写点什么！');
            return;
        }

        var id = $('#info_id').val();

        onReply(id, $('input[name=quote_id]').val(), $('.user_reply').val());
    });

    // $('.reply_body').on('click', function () {
    //     if ($('.top .top-login').length > 0) {
    //         showLogin();
    //     }
    // });
    //
    // $('.login_btn').on('click', function () {
    //     if ($('.top .top-login').length > 0) {
    //         showLogin();
    //         return;
    //     }
    // });
});

window.getReply = function () {
    var id = $('#info_id').val();
    if (!id || replyPage <= 0)
        return;

    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/a/replies?id=' + id + '&page=' + replyPage,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data == '')
                return;
            if (data.message !== undefined) {
                alert('操作失败:' + data.message);
                return;
            }
            if (data.data === undefined) {
                alert('操作失败');
                return;
            }
            var newlist = '';
            for (var i = 0; i < data.data.length; i++) {
                var info = data.data[i];

                newlist += '<div class="reply_item">';
                if (info.author_avatar_url != null && info.author_avatar_url != '') {
                    newlist += '<a class="reply_avatar" href="' + ROOT + '/user/id/' + info.author_id + '">';
                    newlist += '<img src="' + info.author_avatar_url + '?w=52&h=52&s=3" /></a>';
                } else {
                    newlist += '<a class="reply_avatar" href="' + ROOT + '/user/id/' + info.author_id + '">';
                    newlist += '<img src="' + ROOT + '/static/images/no-avatar.png" /></a>';
                }
                newlist += '<div class="reply_right">';
                newlist += '<div class="reply_top">';
                newlist += '<div class="reply_top_left">';
                newlist += '<div class="reply_name">' + info.author_nickname + '</div>';
                newlist += '<br />';
                newlist += '<div class="reply_time">' + info.creation_time + '</div>';
                newlist += '</div>';

                newlist += '<div class="reply_top_right">';
                newlist += '<div class="reply_sub_count" dataid="' + info.id + '">' + info.sub_comment_count + '</div>';
                newlist += '<div class="reply_like" dataid="' + info.id + '">' + info.like_count + '</div>';
                newlist += '<div class="reply_report" data-id="' + info.id + '"><div class="report-icon"></div>举报</div>';
                newlist += '</div>';

                newlist += '</div>';
                newlist += '<div class="reply_middle">';
                newlist += '<div class="reply_content">' + info.text + '</div>';
                newlist += '</div>';
                // newlist += '<div class="reply_bottom">';
                // newlist += '<div class="reply_button" data-value="' + info.id + '"><a>回复</a></div>';
                // if (info.sub_comment_count > 0) {
                //     newlist += '<div class="reply_sub_count" data-value="' + info.id + '">';
                //     newlist += '回复(' + info.sub_comment_count + ')';
                //     newlist += '<a class="glyphicon glyphicon-chevron-down"></a></div>';
                // } else {
                //     newlist += '<div class="reply_sub_count" data-value="' + info.id + '" disabled="disabled">';
                //     newlist += '回复(' + info.sub_comment_count + ')</div>';
                // }
                // newlist += '<div class="reply_like_button" data-value="' + info.id + '">';
                // newlist += '<div class="reply_like"><img src="' + ROOT + '/static/images/btn-like.png">';
                // newlist += '<span>' + info.like_count + '</span>';
                // newlist += '</div>';
                // newlist += '<div class="reply_dislike">';
                // newlist += '<img src="' + ROOT + '/static/images/btn-dislike.png">';
                // newlist += '<span>' + info.dislike_count + '</span>';
                // newlist += '</div>';
                // newlist += '</div>';
                // newlist += '</div>';
                newlist += '</div>';

                newlist += '<div class="reply_sub_list" data-value="' + info.id + '" page="1">';
                if (info.sub_comments && info.sub_comments.length > 0) {
                    for (var j = 0; j < info.sub_comments.length; j++) {
                        var tmp = info.sub_comments[j];

                        newlist += '<div class="reply_item">';
                        if (tmp.author_avatar_url != null && tmp.author_avatar_url != '') {
                            newlist += '<a class="reply_avatar" href="' + ROOT + '/user/id/' + tmp.author_id + '">';
                            newlist += '<img src="' + tmp.author_avatar_url + '?w=52&h=52&s=3" /></a>';
                        } else {
                            newlist += '<a class="reply_avatar" href="' + ROOT + '/user/id/' + tmp.author_id + '">';
                            newlist += '<img src="' + ROOT + '/static/images/no-avatar.png" /></a>';
                        }
                        newlist += '<div class="reply_right">';
                        newlist += '<div class="reply_top">';
                        newlist += '<div class="reply_top_left">';
                        newlist += '<div class="reply_name">' + tmp.author_nickname + '</div>';
                        newlist += '<br />';
                        newlist += '<div class="reply_time">' + tmp.creation_time + '</div>';
                        newlist += '</div>';

                        newlist += '<div class="reply_top_right">';
                        newlist += '<div class="reply_sub_count" dataid="' + tmp.id + '"></div>';
                        newlist += '<div class="reply_like" dataid="' + tmp.id + '">' + tmp.like_count + '</div>';
                        newlist += '<div class="reply_report" data-id="' + info.id + '"><div class="report-icon"></div>举报</div>';
                        newlist += '</div>';

                        newlist += '</div>';
                        newlist += '<div class="reply_middle">';
                        newlist += '<div class="reply_content">';
                        if (tmp.ref_comment && tmp.ref_comment.id != info.id) {
                            newlist += '@<span>' + tmp.ref_comment.author_nickname + ':</span>';
                        }
                        newlist += tmp.text + '</div>';
                        newlist += '</div>';
                        newlist += '</div>';
                    }
                }
                newlist += '</div>';
                newlist += '</div>';
                newlist += '<div class="dividing-line"></div>';
            }

            if (replyPage == 1)
                $('.reply_list').html(newlist);
            else
                $('.reply_list').append(newlist);

            replyEventBinding();

            if (data.total == 0) {
                $('.reply .no-reply').css('display', 'block');
                $('.reply .more').css('display', 'none');
            } else if (data.total <= replyPage * 20) {
                $('.reply .no-reply').css('display', 'none');
                $('.reply .more').css('display', 'block');
                $('.reply .more').addClass('no-more');
                replyPage = 0;
            } else
                replyPage++;

            $('.reply_sub_count').on('click', function () {
                var id = $(this).attr('dataid');
                if (!id) return;
                if ($('.reply_quote_btn[dataid=' + id + ']').length > 0) {
                    $('.reply_quote_btn[dataid=' + id + ']').parents('.reply_quote').remove();
                    return;
                }
                // if ($(this).hasClass('open')) {
                //     $(this).removeClass('open');
                //     $(this).children('.glyphicon-chevron-up').addClass('glyphicon-chevron-down');
                //     $(this).children('.glyphicon-chevron-up').removeClass('glyphicon-chevron-up');
                //
                //     var id = $(this).attr('data-value');
                //     $('.reply_sub_list[data-value=' + id + ']').css('display', 'none');
                // } else {
                //     $(this).addClass('open');
                //     $(this).children('.glyphicon-chevron-down').addClass('glyphicon-chevron-up');
                //     $(this).children('.glyphicon-chevron-down').removeClass('glyphicon-chevron-down');
                //
                //     var id = $(this).attr('data-value');
                //     $('.reply_sub_list[data-value=' + id + ']').css('display', 'block');
                //     getSubReply(id);
                // }
                var html = '<div class="reply_quote">';
                html += '<textarea class="reply_quote_body"></textarea>';
                html += '<div class="reply_quote_btn" dataid="' + id + '">发表</div>';
                html += '</div>';

                $(this).parents('.reply_right').append(html);

                $('.reply_quote_btn').off('click');
                $('.reply_quote_btn').on('click', function () {
                    var id = $('#info_id').val();
                    var qid = $(this).attr('dataid');
                    var text = $(this).parents('.reply_quote').children('.reply_quote_body').val();
                    onReply(id, qid, text);
                });
            });
        },
        error: function (data) {
            console.log(data);
            if (data.message !== undefined)
                alert('获取评论列表失败:' + data.message);
            else
                alert('获取评论列表失败');
        }
    });
};

window.getSubReply = function (id) {
    var page = $('.reply_sub_list[data-value=' + id + ']').attr('page');
    if (page == 0)
        return;

    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/a/sub_replies?id=' + id + '&page=' + page,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data !== undefined && data.message !== undefined) {
                console.log(data);
                return;
            }

            var newlist = '';
            for (var i = 0; i < data.data.length; i++) {
                var info = data.data[i];

                newlist += '<div class="reply_sub_item">';
                if (info.author_avatar_url != null && info.author_avatar_url != '') {
                    newlist += '<a class="reply_avatar" href="' + ROOT + '/user/id/' + info.author_id + '">';
                    newlist += '<img src="' + info.author_avatar_url + '?w=52&h=52&s=3" /></a>';
                } else {
                    newlist += '<a class="reply_avatar" href="' + ROOT + '/user/id/' + info.author_id + '">';
                    newlist += '<img src="' + ROOT + '/static/images/no-avatar.png" /></a>';
                }
                newlist += '<div class="reply_right">';

                newlist += '<div class="reply_top">';
                newlist += '<div class="reply_name">' + info.author_nickname + '</div>';
                newlist += '<div class="reply_time"></div>';
                newlist += '</div>';

                newlist += '<div class="reply_middle">';
                newlist += '<div class="reply_content">' + info.text + '</div>';
                newlist += '</div>';

                newlist += '<div class="reply_bottom">';
                newlist += '<div class="reply_button" data-value="' + info.id + '"><a>回复</a></div>';
                newlist += '<div class="reply_like_button" data-value="' + info.id + '">';
                newlist += '<div class="reply_like"><img src="' + ROOT + '/static/images/btn-like.png">';
                newlist += '<span>' + info.like_count + '</span>';
                newlist += '</div>';
                newlist += '<div class="reply_dislike"><img src="' + ROOT + '/static/images/btn-dislike.png">';
                newlist += '<span>' + info.dislike_count + '</span>';
                newlist += '</div>';
                newlist += '</div>';

                newlist += '</div>';
                newlist += '</div>';
                newlist += '</div>';
            }

            if (data.total <= 10 * page) {
                $('.reply_sub_list[data-value=' + id + ']').attr('page', 0);
            } else {
                $('.reply_sub_list[data-value=' + id + ']').attr('page', page + 1);
                newlist += '<a class="reply_load_more" data-value="' + id + '">查看更多回复</a>';
            }

            $('.reply_load_more[data-value=' + id + ']').remove();
            $('.reply_sub_list[data-value=' + id + ']').append(newlist);

            replyEventBinding();
        },
        error: function (data) {
            console.log(data);
        }
    });
};

window.replyEventBinding = function () {
    $('.reply_button').on('click', function () {
        if ($('.top .top-login').length > 0) {
            showLogin();
            return;
        }

        var id = $(this).attr('data-value');
        $('input[name=quote_id]').val(id);
        $('.user_reply').focus();
    });

    $('.reply_like').on('click', function () {
        if ($('.top .top-login').length > 0) {
            showLogin();
            return;
        }

        var p = $(this);
        if (p.hasClass('clicked'))
            return;
        var id = p.parent().attr('data-value');
        $.ajax({
            type: 'post',
            async: false,
            url: ROOT + '/a/reply_like?id=' + id,
            data: null,
            contentType: 'application/json',
            dataType: 'json',
            success: function (data) {
                if (data != '') {
                    p.find('span').text(data);
                } else {
                    var n = p.find('span').text();
                    p.find('span').text(Number(n) + 1);
                }
                p.addClass('clicked');
            },
            error: function (data) {
                console.log(data);
            }
        });
    });

    $('.reply_dislike').on('click', function () {
        if ($('.top .top-login').length > 0) {
            showLogin();
            return;
        }

        var p = $(this);
        if (p.hasClass('clicked'))
            return;
        var id = p.parent().attr('data-value');
        $.ajax({
            type: 'post',
            async: false,
            url: ROOT + '/a/reply_dislike?id=' + id,
            data: null,
            contentType: 'application/json',
            dataType: 'json',
            success: function (data) {
                if (data != '') {
                    p.find('span').text(data);
                } else {
                    var n = p.find('span').text();
                    p.find('span').text(Number(n) + 1);
                }
                p.addClass('clicked');
            },
            error: function (data) {
                console.log(data);
            }
        });
    });

    $('.reply_load_more').on('click', function () {
        var id = $(this).attr('data-value');
        getSubReply(id);
    });

    $('.reply_report').on('click', function () {
        var data = {
            'source': 'cms',
            'type': 'comment',
            'source_id': $(this).data('id'),
            'title': $('.title').text()
        };
        showReportDlg(3, data, function (id) {
        });
    });
};

window.onReply = function (id, qid, text) {
    if ($('input[name=userid]').val() == '') {
        showLogin();
        return;
    }

    var data = {
        'ref_comment_id': qid,
        'text': text
    };

    $.ajax({
        type: 'post',
        async: false,
        url: ROOT + '/a/add_reply?id=' + id,
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data !== undefined && data.message !== undefined) {
                alert('发表回复失败:' + data.message);
                return;
            } else {
                console.log(data);
                // alert('发表回复成功！');
                // location.reload();

                $('.user_reply').val('');

                replyPage = 1;
                getReply();
            }
        },
        error: function (data) {
            if (data.message !== undefined) {
                console.log(data.message);
                alert('发表失败:' + data.message);
            } else {
                console.log(data);
                alert('发表失败');
            }
        }
    });
};


/***/ }),
/* 4 */
/***/ (function(module, exports) {

var insertvideos = [];
var insertlives = [];
var insertimgs = [];
var insertpicturesets = [];
var insertaudios = [];

var allcolumns = [];
var columninfo = [];

function replacevideo(body) {
    var patt = new RegExp('<!--VIDEO#[0-9]+,[0-9]+,[0-9]+-->', 'gim');
    var result = null;
    while ((result = patt.exec(body)) != null) {
        var substrs = result;
        for (var i = 0; i < substrs.length; i++) {
            var substr = substrs[i];
            var videoinfo = substr.match(/\d+/g);
            var id = videoinfo[0];
            var width = videoinfo[1];
            var height = videoinfo[2];
            if (width == 0) {
                width = '100%';
            } else {
                width = width + 'px';
            }
            if (height == 0) {
                height = '100%';
            } else {
                height = height + 'px';
            }

            var newhtml = '<div id="video_' + id + '" class="content-video" data-src="' + id + '" ';
            newhtml += 'style="width: ' + width + '; height: ' + height + '; max-width: 100%;" />';
            var newpatt = new RegExp(substr, 'gim');
            body = body.replace(newpatt, newhtml);
        }
    }

    return body;
}

function replaceaudio(body) {
    var patt = new RegExp('<!--AUDIO#[0-9]+,[0-9]+,[0-9]+-->', 'gim');
    var result = null;
    while ((result = patt.exec(body)) != null) {
        var substrs = result;
        for (var i = 0; i < substrs.length; i++) {
            var substr = substrs[i];
            var audioinfo = substr.match(/\d+/g);
            var id = audioinfo[0];
            var width = audioinfo[1];
            var height = audioinfo[2];
            if (width == 0) {
                width = '100%';
            } else {
                width = width + 'px';
            }
            if (height == 0) {
                height = '100%';
            } else {
                height = height + 'px';
            }

            var newhtml = '<div id="audio_' + id + '" class="content-audio" data-src="' + id + '" ';
            newhtml += 'style="width: ' + width + '; height: ' + height + '; max-width: 100%;" />';
            var newpatt = new RegExp(substr, 'gim');
            body = body.replace(newpatt, newhtml);
        }
    }

    return body;
}

function replacelive(body) {
    var patt = new RegExp('<!--LIVE#[0-9]+,[0-9]+,[0-9]+-->', 'gim');
    var result = null;
    while ((result = patt.exec(body)) != null) {
        var substrs = result;
        for (var i = 0; i < substrs.length; i++) {
            var substr = substrs[i];
            var videoinfo = substr.match(/\d+/g);
            var id = videoinfo[0];
            var width = videoinfo[1];
            var height = videoinfo[2];
            if (width == 0) {
                width = '100%';
            } else {
                width = width + 'px';
            }
            if (height == 0) {
                height = '100%';
            } else {
                height = height + 'px';
            }

            var newhtml = '<div id="live_' + id + '" class="content-live" data-src="' + id + '" ';
            newhtml += 'style = "width: ' + width + '; height: ' + height + '; max-width: 100%;" />';
            var newpatt = new RegExp(substr, 'gim');
            body = body.replace(newpatt, newhtml);
        }
    }

    return body;
}

function replaceimg(body) {
    var patt = new RegExp('<!--PICTURE#[0-9]+,[0-9]+,[0-9]+-->', 'gim');
    var result = null;
    while ((result = patt.exec(body)) != null) {
        var substrs = result;
        for (var i = 0; i < substrs.length; i++) {
            var substr = substrs[i];
            var videoinfo = substr.match(/\d+/g);
            var id = videoinfo[0];
            var width = videoinfo[1];
            var height = videoinfo[2];

            var imginfo = getimginfobyid(id);
            if (!imginfo)
                continue;
            if (width == 0)
                width = imginfo.width;
            if (height == 0)
                height = imginfo.height;
            var url = imginfo.url + '?w=' + width + '&s=1';
            var newhtml = '<img src="' + url + '" title="" ';
            newhtml += 'style="max-width: 100%;" />';
            var newpatt = new RegExp(substr, 'gim');
            body = body.replace(newpatt, newhtml);
        }
    }

    return body;
}

function replacepictureset(body) {
    var patt = new RegExp('<!--PICTURESET#[0-9]+-->', 'gim');
    var result = null;
    while ((result = patt.exec(body)) != null) {
        var substrs = result;
        for (var i = 0; i < substrs.length; i++) {
            var substr = substrs[i];
            var videoinfo = substr.match(/\d+/g);
            var id = videoinfo[0];

            var info = getpicturesetinfobyid(id);

            var newhtml = '';
            // for (var i = 0; i < info.pictures.length; i++) {
            //     var url = info.pictures[i].url + '?w=' + info.pictures[i].width + '&s=1';
            //     var width = info.pictures[i].width;
            //     if (width && !isNaN(parseInt(width)) && parseInt(width) > 0) {
            //         width = 'width: ' + info.pictures[i].width + 'px;';
            //     } else {
            //         width = '';
            //     }
            //     newhtml += '<img src="' + url + '" style="' + width + 'max-width: 800px;" />';
            // }
            if (info.pictures.length == 1) {
                newhtml += '<img src="' + info.pictures[0].url + '?w=800&h=0&s=1" />';
            } else if (info.pictures.length > 1) {
                newhtml += '<div class="big-img"><img /></div>';
                newhtml += '<div class="nav-imgs"><ul>\n';
                for (var j = 0; j < info.pictures.length; j++) {
                    var obj = info.pictures[j];
                    newhtml += '<li class="nav-img"><img src="' + obj.url + '?w=54&h=54&s=3" /></li>\n';
                }
                newhtml += '</ul></div>\n';
            }

            var newpatt = new RegExp(substr, 'gim');
            body = body.replace(newpatt, newhtml);
        }
    }

    return body;
}

function getimginfobyid(id) {
    for (var i = 0; i < insertimgs.length; i++) {
        if (id == insertimgs[i].id) {
            return insertimgs[i];
        }
    }

    return null;
}

function getliveinfo(id) {
    for (var i = 0; i < insertlives.length; i++) {
        if (id == insertlives[i].id) {
            return insertlives[i];
        }
    }

    return null;
}

function getpicturesetinfobyid(id) {
    for (var i = 0; i < insertpicturesets.length; i++) {
        if (id == insertpicturesets[i].id) {
            return insertpicturesets[i];
        }
    }

    return null;
}

function getvideoinfo(id) {
    for (var i = 0; i < insertvideos.length; i++) {
        if (id == insertvideos[i].id) {
            return insertvideos[i];
        }
    }

    return null;
}

function getaudioinfo(id) {
    for (var i = 0; i < insertaudios.length; i++) {
        if (id == insertaudios[i].id) {
            return insertaudios[i];
        }
    }

    return null;
}

module.exports = {
    setcontentinfo: function (extension) {
        if (extension.videos && extension.videos.length > 0) {
            if (typeof(extension.videos[0]) == 'object') {
                insertvideos = extension.videos;
            } else {
                var ids = '';
                for (var i = 0; i < extension.videos.length; i++) {
                    ids += extension.videos[i] + ',';
                    if (i == extension.videos.length - 1)
                        ids = ids.substr(0, ids.length - 1);
                }
                insertvideos = getVideos(ids);
            }
        }

        if (extension.audios && extension.audios.length > 0) {
            if (typeof(extension.audios[0]) == 'object') {
                insertaudios = extension.audios;
            } else {
                var ids = '';
                for (var i = 0; i < extension.audios.length; i++) {
                    ids += extension.audios[i] + ',';
                    if (i == extension.audios.length - 1)
                        ids = ids.substr(0, ids.length - 1);
                }
                insertaudios = getAudios(ids);
            }
        }

        if (extension.lives && extension.lives.length > 0) {
            if (typeof(extension.lives[0]) == 'object') {
                insertlives = extension.lives;
            } else {
                var ids = '';
                for (var i = 0; i < extension.lives.length; i++) {
                    ids += extension.lives[i] + ',';
                    if (i == extension.lives.length - 1)
                        ids = ids.substr(0, ids.length - 1);
                }
                insertlives = getLives(ids);
            }
        }

        if (extension.pictures && extension.pictures.length > 0) {
            if (typeof(extension.pictures[0]) == 'object') {
                insertimgs = extension.pictures;
            } else {
                var ids = '';
                for (var i = 0; i < extension.pictures.length; i++) {
                    ids += extension.pictures[i] + ',';
                    if (i == extension.pictures.length - 1)
                        ids = ids.substr(0, ids.length - 1);
                }
                insertimgs = getPictures(ids);
            }
        }

        if (extension.picturesets && extension.picturesets.length > 0) {
            if (typeof(extension.picturesets[0]) == 'object') {
                insertpicturesets = extension.picturesets;
            } else {
                var ids = '';
                for (var i = 0; i < extension.picturesets.length; i++) {
                    ids += extension.picturesets[i] + ',';
                    if (i == extension.picturesets.length - 1)
                        ids = ids.substr(0, ids.length - 1);
                }
                insertpicturesets = getPicturesets(ids);
            }
        }
    },

    geteditorbody: function (body) {
        body = replacevideo(body);
        body = replaceaudio(body);
        body = replacelive(body);
        body = replaceimg(body);
        body = replacepictureset(body);
        return body;
    },

    playlive: function (id) {
        var lives = getliveinfo(id);
        if (!lives)
            return null;
        var urls = [];
        urls.push(lives.rtmpUrl);
        urls.push(lives.flvUrl);
        urls.push(lives.m3u8Url);

        return urls;
    },

    playvideo: function (id) {
        var videos = getvideoinfo(id);
        if (!videos || !videos.versions)
            return null;
        var urls = [];
        for (var j = 0; j < videos.versions.length; j++) {
            urls.push(videos.versions[j].url);
        }

        return urls;
    },

    playaudio: function (id) {
        var audios = getaudioinfo(id);
        if (audios == null || !audios)
            return null;
        if (audios.versions && audios.versions.length > 0) {
            var obj = {
                nAppWidth: 500,
                strTitle: audios.title,
                strAudioUrl: audios.versions[0].url,
                blNeedUI: true
            };
            return obj;
        }

        return null;
    }
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(0);
__webpack_require__(6);
__webpack_require__(1);
module.exports = __webpack_require__(13);


/***/ }),
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

﻿var $ = __webpack_require__(2);
var con = __webpack_require__(4);
var code = __webpack_require__(14);
__webpack_require__(3);
__webpack_require__(15);

// get_reply 获取回复
// submitQuestion 提交问卷,submitVote 提交投票,submitSignup 提交报名

var players = [];
var infoAnonymous = true;
var enableCaptcha = false;
var eventStart = null;
var eventEnd = null;
var dayLimit = 0;
var totalLimit = 0;

$('.report').on('click', function () {
    var data = {
        source: 'cms',
        type: 'content',
        source_id: parseInt($('#info_id').val()),
        title: $('.title').text()
    };
    showReportDlg(2, data, function (id) { });
});

$(function () {
    getReply(replyPage);
    getNewest();
    getCorrelates();
    var columns = getColumnIndex($('.column').attr('dataid'));
    if (columns) {
        $('.column').html(columns);
    }

    $('.correlates-change').on('click', function () {
        getCorrelates();
    });

    $('.abs-reply').on('click', function () {
        $('.user_reply').focus();
        if ($('.top .top-login').length > 0) {
            showLogin();
            return;
        }
    });

    $('.abs-collect').on('click', function () {
        if ($('.top .top-login').length > 0) {
            showLogin();
            return;
        }
    });

    var num = 0;
    var type = $('#info_type').val();
    var extension = $('#info_extension').val();
    if (extension) extension = JSON.parse(extension);
    var now = Date.now() / 1000;

    var components = $('#info_body_components').val();
    if (components) {
        components = JSON.parse(components);
        con.setcontentinfo(components);
        var body = $('#content_body').html();
        body = con.geteditorbody(body);
        $('#content_body').html(body);
        for (var i = 0; i < $('.content-live').length; i++) {
            var id = $($('.content-live')[i]).attr('data-src');
            var urls = con.playlive(id);
            var playerid = 'player-live-' + id;
            $($('.content-live')[i]).html(
                '<video id="' +
                playerid +
                '" number="' +
                num++ +
                '" style="min-width: 800px; min-height: 450px;" class="video-js vjs-big-play-centered"></video>'
            );
            var play;
            startPlay(urls[0], playerid);
            players.push(play);
        }
        for (var i = 0; i < $('.content-video').length; i++) {
            var id = $($('.content-video')[i]).attr('data-src');
            var urls = con.playvideo(id);
            if (!urls) continue;
            urls.sort(function (a, b) {
                if (a.substr(-5) == '.m3u8') return -1;
                else if (b.substr(-5) == '.m3u8') return 1;
                else return 0;
            });
            var playerid = 'player-video-' + id;
            $($('.content-video')[i]).html(
                '<video id="' +
                playerid +
                '" number="' +
                num++ +
                '" style="min-width: 800px; min-height: 450px;" class="video-js vjs-big-play-centered"></video>'
            );
            var ads = getVideoAds(id);
            var play;
            startPlay(urls[0], playerid);
            players.push(play);
        }
        for (var i = 0; i < $('.content-audio').length; i++) {
            var id = $($('.content-audio')[i]).attr('data-src');
            var obj = con.playaudio(id);
            if (!obj) continue;
            var playerid = 'player-audio-' + id;
            $($('.content-audio')[i]).html(
                '<video id="' +
                playerid +
                '" number="' +
                num++ +
                '" style="width: 800px; height: 50px;" class="video-js vjs-big-play-centered"></video>'
            );
            var play;
            startPlay(obj.strAudioUrl, playerid);
            players.push(play);
        }
        $('.like-button').css('display', 'block');
    }
    if (type == 'video') {
        if (extension && extension.videos.length > 0) {
            $('#content_body').prepend(
                '<video id="content" style="min-width: 800px; min-height: 450px;" class="video-js vjs-big-play-centered"></video>'
            );
            var urls = [];
            for (var i = 0; i < extension.videos[0].versions.length; i++) {
                if (extension.videos[0].versions[i].url) urls.push(extension.videos[0].versions[i].url);
            }
            urls.sort(function (a, b) {
                if (a.substr(-5) == '.m3u8') return -1;
                else if (b.substr(-5) == '.m3u8') return 1;
                else return 0;
            });

            // var ads = getVideoAds(extension.videos[0].id);
            var play = startPlay(urls[0], 'content');
            console.log(play.controls);
            console.log('play.length');
            players.push(play);
        } else {
            $('#content_body').html('<div class="non-existent">视频已被删除</div>');
        }
        $('.like-button').css('display', 'block');
    } else if (type == 'live') {
        if (extension !== undefined && extension != null) {
            $('#content_body').prepend(
                '<video id="content" style="min-width: 800px; min-height: 450px;" class="video-js vjs-big-play-centered"></video>'
            );
            var data = getLives(extension.live_id);
            if (data[0]) {
                var urls = [];
                urls.push(data[0].rtmpUrl);
                urls.push(data[0].flvUrl);
                urls.push(data[0].m3u8Url);
                var play;
                // startPlay(play, { urls: urls, id: 'content' });
                startPlay(urls[0], 'content');
                players.push(play);
            }
        }
    } else if (type == 'pictureset') {
        if (extension !== undefined && extension != null) {
            var data = getPicturesets(extension.pictureset_id);
            if (data[0]) {
                var html = '';
                // for (var i = 0; i < data[0].pictures.length; i++) {
                //     html += '<div class="art-pictureset">';
                //     html += '<img src="' + data[0].pictures[i].url + '" width="' + data[0].pictures[i].width + '" height="' + data[0].pictures[i].height + '" />';
                //     html += '<br />';
                //     html += '<span>' + data[0].pictures[i].introduction + '</span>';
                //     html += '</div>';
                // }
                if (data[0].pictures.length == 1) {
                    html += '<img src="' + data[0].pictures[0].url + '?w=720&h=0&s=1" />';
                } else if (data[0].pictures.length > 1) {
                    html += '<div class="big-img"><img /></div>';
                    html += '<div class="nav-imgs"><ul>\n';
                    for (var i = 0; i < data[0].pictures.length; i++) {
                        var info = data[0].pictures[i];
                        html += '<li class="nav-img"><img src="' + info.url + '?w=54&h=54&s=3" /></li>\n';
                    }
                    html += '</ul></div>\n';
                }
                $('#content_body').prepend(html);
            }
        }
        $('.like-button').css('display', 'block');
    } else if (type == 'questionnaire') {
        infoAnonymous = extension.anonymous;
        eventStart = extension.start_time;
        eventEnd = extension.stop_time;

        $('#content_body').html(html);
    } else if (type == 'vote') {
        infoAnonymous = extension.anonymous;
        if (extension.strategies) {
            for (var i = 0; i < extension.strategies.length; i++) {
                if (extension.strategies[i].type == 2) {
                    dayLimit = extension.strategies[i].day_limit;
                    totalLimit = extension.strategies[i].total_limit;
                }
            }
        }
        eventStart = extension.start_time;
        eventEnd = extension.stop_time;
    } else if (type == 'special') {
    } else if (type == 'signup') {
        infoAnonymous = extension.anonymous;
        enableCaptcha = extension.enable_captcha;
        eventStart = extension.start_time;
        eventEnd = extension.stop_time;
    } else if (type == 'audio') {
        if (extension && extension.audios.length > 0) {
            $('#content_body').html(
                '<video id="content" style="width: 800px; height:100px;" class="video-js vjs-big-play-centered"></video>'
            );
            var play;
            var obj = {
                nAppWidth: 500,
                strTitle: extension.audios[0].title,
                strAudioUrl: extension.audios[0].versions[0].url,
                blNeedUI: true
            };
            // startAudioPlay(play, obj, 'content');
            startPlay(obj.strAudioUrl, 'content');
            players.push(play);
        }
    } else if (type == 'show') {
    }

    $('input').iCheck({
        checkboxClass: 'icheckbox_square-red',
        radioClass: 'iradio_square-red'
    });

    $('.like-button').on('click', function () {
        if ($(this).hasClass('clicked')) return;
        else {
            if ($('.top .top-login').length > 0) {
                showLogin();
            } else {
                onLike();
            }
        }
    });

    $('.big-img').on('mousemove', function (event) {
        var x = event.offsetX;
        if (x < event.target.clientWidth / 2) {
            $('.big-img').removeClass('mouseright');
            $('.big-img').addClass('mouseleft');
        } else {
            $('.big-img').removeClass('mouseleft');
            $('.big-img').addClass('mouseright');
        }
    });

    $('.big-img').on('click', function (event) {
        if ($('.big-img').hasClass('mouseleft')) {
            imageClick($('.nav-img.selected').prev());
        } else if ($('.big-img').hasClass('mouseright')) {
            imageClick($('.nav-img.selected').next());
        }
    });

    $('.nav-img').on('click', function () {
        if ($(this).hasClass('selected')) {
            return;
        }
        imageClick($(this));
    });

    if ($('.nav-imgs .nav-img').length > 0) {
        $('.nav-imgs .nav-img:first').click();
    }

    if (eventStart && eventEnd) {
        if (eventStart > eventEnd) {
            alert('活动时间未确定!');
            $('.art-submit').css('display', 'none');
            $('#content_body *').attr('disabled', true);
            return;
        } else if (now < eventStart) {
            alert('活动未开始!');
            $('.art-submit').css('display', 'none');
            $('#content_body *').attr('disabled', true);
            return;
        } else if (now >= eventEnd) {
            alert('活动已结束!');
            $('.art-submit').css('display', 'none');
            $('#content_body *').attr('disabled', true);
            return;
        }
    }

    if (!infoAnonymous) {
        if ($('.top .top-login').length > 0) {
            showLogin();
        }
    }

    if (enableCaptcha) {
        code.createCode();
        $('.checkcode').css('display', 'block');
    }
});

function imageClick(item) {
    if (item.length == 0) {
        return;
    }

    $('.nav-img.selected').removeClass('selected');
    item.addClass('selected');
    var url = item.children().attr('src');
    if (url.indexOf('?') > 0) {
        url = url.substr(0, url.indexOf('?'));
    }
    $('.big-img img').attr('src', url);
}

function LastImage() {
    imageClick($('.nav-img.selected').prev());
}

function NextImage() {
    imageClick($('.nav-img.selected').next());
}

function onLike() {
    var id = $('#info_id').val();
    $.ajax({
        type: 'post',
        async: false,
        url: ROOT + '/a/like?id=' + id,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data !== undefined && data.message !== undefined) {
                console.log(data);
                alert(data.message);
                return;
            } else {
                $('.like-button').addClass('clicked');
            }
        },
        error: function (data) {
            if (data.message !== undefined) {
                console.log(data.message);
                alert('点赞失败:' + data.message);
            } else {
                console.log(data);
                alert('点赞失败');
            }
        }
    });
}

$(window).scroll(function () {
    // 下面这句主要是获取网页的总高度，主要是考虑兼容性所以把Ie支持的documentElement也写了，这个方法至少支持IE8
    var htmlHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
    // clientHeight是网页在浏览器中的可视高度，
    var clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
    // scrollTop是浏览器滚动条的top位置，
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    // 通过判断滚动条的top位置与可视网页之和与整个网页的高度是否相等来决定是否加载内容；
    if (scrollTop + clientHeight >= htmlHeight) {
        getReply();
    }

    if ($('.banner').length > 0 && scrollTop < 398) {
        $('.abs-left').css({
            position: 'absolute',
            top: 0
        });
    } else {
        $('.abs-left').css({
            position: 'fixed',
            top: '48px'
        });
    }
});

// 获取专题内容
$(function () {
    for (var i = 0; i < $('.art-special-content').length; i++) {
        var id = $($('.art-special-content')[i]).attr('contentid');
        $.ajax({
            type: 'get',
            async: false,
            url: ROOT + '/a/contents?id=' + id,
            data: null,
            contentType: 'application/json',
            dataType: 'json',
            success: function (data) {
                if (data !== undefined && data.message !== undefined) {
                    console.log(data);
                    return;
                }

                var newlist = '';
                for (var j = 0; j < data.length; j++) {
                    var info = data[j];
                    if (info.thumbnail_urls === undefined || info.thumbnail_urls == null || info.thumbnail_urls == '')
                        info.thumbnail_urls = [];
                    if (info.type == 4) {
                        newlist += '<div class="newsItem">';
                        newlist += '<div class="news_body">';
                        newlist += '<a class="news_title" href="' + info.url + '" target="_blank">' + info.title + '</a>';
                        newlist += '</div>';
                        newlist += '<div class="newsPicture">';
                        for (var j = 0; j < info.thumbnail_urls.length; j++) {
                            if (j == 4) break;
                            newlist +=
                                '<a href="' +
                                info.url +
                                '" target="_blank"><img src="' +
                                info.thumbnail_urls[j] +
                                '?w=156&h=102&s=3' +
                                '"/></a>';
                        }
                        newlist += '</div>';
                        newlist += '<div class="news_info">';
                        newlist += '<div class="user">' + info.author_nickname + '</div>';
                        newlist += '<div class="time">' + info.publish_time + '</div>';
                        newlist += '<div class="reply">';
                        if (info.comment_count > 0) newlist += '<div class="reply_count">' + info.comment_count + '评论</div>';
                        if (info.view_count > 0) newlist += '<div class="reply_count">' + info.view_count + '浏览</div>';
                        newlist += '</div>';
                        newlist += '</div>';
                        newlist += '</div>';
                    } else {
                        newlist += '<div class="newsItem">';
                        if (info.thumbnail_urls.length > 0) {
                            newlist += '<div class="newsPicture">';
                            newlist +=
                                '<a href="' +
                                info.url +
                                '" target="_blank"><img src="' +
                                info.thumbnail_urls[0] +
                                '?w=156&h=102&s=3' +
                                '"/></a>';
                            newlist += '</div>';
                        } else if (info.publisher_avatar_url) {
                            newlist += '<div class="newsPicture">';
                            newlist +=
                                '<a href="' +
                                info.url +
                                '" target="_blank"><img src="' +
                                info.publisher_avatar_url +
                                '?w=156&h=102&s=3' +
                                '"/></a>';
                            newlist += '</div>';
                        }
                        newlist += '<div class="alignMiddle">';
                        newlist += '<div class="newsInfo">';
                        newlist += '<div class="news_body">';
                        newlist += '<a class="news_title" href="' + info.url + '" target="_blank">' + info.title + '</a>';
                        newlist += '<span class="news_summary">' + info.summary + '</span>';
                        newlist += '</div>';
                        newlist += '</div>';
                        newlist += '</div>';
                        newlist += '</div>';
                        newlist += '</div>';
                    }
                }

                $($('.art-special-content')[i]).html(newlist);
            },
            error: function (data) {
                console.log(data);
            }
        });
    }

    // for (var i = 0; i < $('.art-special-video').length; i++) {
    //     var id = $($('.art-special-video')[i]).attr('contentid');
    //     $.ajax({
    //         type: 'get',
    //         async: false,
    //         url: ROOT + '/config/video?id=' + id,
    //         data: null,
    //         contentType: 'application/json',
    //         dataType: 'json',
    //         success: function (data) {
    //             if (data !== undefined && data.message !== undefined) {
    //                 console.log(data);
    //                 return;
    //             }
    //
    //             var newlist = '';
    //             for (var j = 0; j < data.length; j++) {
    //                 var info = data[j];
    //                 newlist += '<div class="art-special-video-item">';
    //                 newlist += '<div class="art-special-data" data=\'' + JSON.stringify(info) + '\'>';
    //                 newlist += '<img class="art-special-content-video-cover" src="' + info.cover_url + '" />';
    //                 newlist += '<img src="' + ROOT + '/static/images/play.png" class="play-btn" />';
    //                 newlist += '</div>';
    //                 newlist += '</div>';
    //             }
    //
    //             $($('.art-special-video')[i]).html(newlist);
    //         },
    //         error: function (data) {
    //             console.log(data);
    //         }
    //     });
    // }
    //
    // for (var i = 0; i < $('.art-special-pictureset').length; i++) {
    //     var id = $($('.art-special-pictureset')[i]).attr('contentid');
    //     $.ajax({
    //         type: 'get',
    //         async: false,
    //         url: ROOT + '/config/pictureset?id=' + id,
    //         data: null,
    //         contentType: 'application/json',
    //         dataType: 'json',
    //         success: function (data) {
    //             if (data !== undefined && data.message !== undefined) {
    //                 console.log(data);
    //                 return;
    //             }
    //
    //             var newlist = '';
    //             for (var j = 0; j < data.length; j++) {
    //                 var info = data[j];
    //                 newlist += '<div class="art-special-pictureset-item">';
    //                 newlist += '<div class="art-special-data" data=\'' + JSON.stringify(info) + '\'>';
    //                 for (var k = 0; k < info.pictures.length; k++) {
    //                     newlist += '<img class="art-special-pictureset-img" src="' + info.pictures[k].url + '" />';
    //                 }
    //                 newlist += '</div>';
    //                 newlist += '</div>';
    //             }
    //
    //             $($('.art-special-pictureset')[i]).html(newlist);
    //         },
    //         error: function (data) {
    //             console.log(data);
    //         }
    //     });
    // }
    //
    // for (var i = 0; i < $('.art-special-vote').length; i++) {
    //     var id = $($('.art-special-vote')[i]).attr('contentid');
    //     $.ajax({
    //         type: 'get',
    //         async: false,
    //         url: ROOT + '/a/contents?id=' + id,
    //         data: null,
    //         contentType: 'application/json',
    //         dataType: 'json',
    //         success: function (data) {
    //             if (data !== undefined && data.message !== undefined) {
    //                 console.log(data);
    //                 return;
    //             }
    //
    //             var newlist = '';
    //             for (var j = 0; j < data.length; j++) {
    //                 var info = data[j];
    //
    //                 vote += '<div class="art-votes" dataid="' + exdata.id + '">';
    //                 for (var i = 0; i < exdata.topics.length; i++) {
    //                     var info = exdata.topics[i];
    //
    //                     vote += '<div class="art-vote" dataid="' + info.id + '">';
    //                     vote += '<div class="art-vote-number">' + (i + 1) + '</div>';
    //                     vote += '<div class="art-vote-title">';
    //                     if (info.option_type == 1)
    //                         vote += '<img src="' + ROOT + '/static/images/u620.png" />';
    //                     else if (info.option_type == 2)
    //                         vote += '<img src="' + ROOT + '/static/images/u624.png" />';
    //                     else if (info.option_type == 3)
    //                         vote += '<img src="' + ROOT + '/static/images/u622.png" />';
    //                     vote += info.title;
    //                     vote += '</div>';
    //                     vote += '<div class="art-vote-options">';
    //
    //                     for (var j = 0; j < info.options.length; j++) {
    //                         if (info.option_type == 1) {
    //                             vote += '<div class="art-vote-option text">';
    //                             vote += '<input type="radio" name="vote' + info.id + '" value="' + info.options[j].id + '" />' + info.options[j].title;
    //                             if (info.result_type == 1)
    //                                 vote += '<div class="art-vote-result">(' + info.options[j].count + '票)</div>';
    //                             else if (info.result_type == 2)
    //                                 vote += '<div class="art-vote-result">(' + info.options[j].count + '名)</div>';
    //                             vote += '</div>';
    //                         } else if (info.option_type == 2) {
    //                             vote += '<div class="art-vote-option pic">';
    //                             vote += '<div class="art-vote-pic">';
    //                             vote += '<img src="' + info.options[j].picture_url + '" width="216" height="216" />';
    //                             vote += '</div>';
    //                             vote += '<div class="art-vote-checkbox">';
    //                             vote += '<input type="radio" name="vote' + info.id + '" value="' + info.options[j].id + '" />' + info.options[j].title;
    //                             vote += '</div>';
    //                             if (info.result_type == 1)
    //                                 vote += '<div class="art-vote-result">(' + info.options[j].count + '票)</div>';
    //                             else if (info.result_type == 2)
    //                                 vote += '<div class="art-vote-result">(' + info.options[j].count + '名)</div>';
    //                             vote += '</div>';
    //                         } else if (info.option_type == 3) {
    //                             vote += '<div class="art-vote-option video">';
    //                             vote += '<div class="art-vote-video" id="video' + info.options[j].video.id + '" videoid="' + info.options[j].video.id + '">';
    //                             vote += '<img src="' + info.options[j].video.cover_url + '" width="216" height="216" />';
    //                             vote += '<img src="' + ROOT + '/static/images/play.png" class="play-btn" />';
    //                             if (info.options[j].video.versions && info.options[j].video.versions.length > 0) {
    //                                 for (var k = 0; k < info.options[j].video.versions.length; k++) {
    //                                     vote += '<input type="hidden" name="video' + info.options[j].video.id + '" value="' + info.options[j].video.versions[k].url + '">';
    //                                 }
    //                             }
    //                             vote += '</div>';
    //                             vote += '<div class="art-vote-checkbox">';
    //                             vote += '<input type="radio" name="vote' + info.id + '" value="' + info.options[j].id + '" />' + info.options[j].title;
    //                             vote += '</div>';
    //                             if (info.result_type == 1)
    //                                 vote += '<div class="art-vote-result">(' + info.options[j].count + '票)</div>';
    //                             else if (info.result_type == 2)
    //                                 vote += '<div class="art-vote-result">(' + info.options[j].count + '名)</div>';
    //                             vote += '</div>';
    //                         }
    //                     }
    //                     vote += '</div>';
    //                     vote += '</div>';
    //                 }
    //                 vote += '</div>';
    //
    //             }
    //
    //             $($('.art-special-vote')[i]).html(newlist);
    //         },
    //         error: function (data) {
    //             console.log(data);
    //         }
    //     });
    // }
});

$(function () {
    $('.art-submit').on('click', function () {
        if (!infoAnonymous) {
            if ($('.top .top-login').length > 0) {
                showLogin();
            }
        }

        var now = Date.now() / 1000;
        if (eventEnd < now) {
            alert('活动已结束!');
            return;
        }

        if (enableCaptcha) {
            if (code.validate()) {
                if ($('#info_type').val() == 'questionnaire') submitQuestion();
                else if ($('#info_type').val() == 'vote') submitVote();
                else if ($('#info_type').val() == 'signup') submitSignup();
            }
        } else {
            if ($('#info_type').val() == 'questionnaire') submitQuestion();
            else if ($('#info_type').val() == 'vote') submitVote();
            else if ($('#info_type').val() == 'signup') submitSignup();
        }
    });
});

// 投票视频、图片点击处理
$(function () {
    $('.art-vote-video').on('click', function () {
        var video = $(this).attr('id');
        var urls = [];
        if ($('input[name="' + video + '"]').length > 0) {
            for (var i = 0; i < $('input[name="' + video + '"]').length; i++) {
                urls.push($('input[name="' + video + '"]')[i].value);
            }
        }

        $('#viewcontent').html('');
        $('#videoviewdlg').modal('show');
        var play;
        startPlay(urls[0], 'viewcontent');
    });

    $('.art-special-video-item').on('click', function () {
        try {
            var data = $(this)
                .children('.art-special-data')
                .attr('data');
            data = JSON.parse(data);
            if (data.versions && data.versions.length > 0) {
                var urls = [];
                for (var i = 0; i < data.versions.length; i++) {
                    urls.push(data.versions[i].url);
                }

                $('#viewcontent').html('');
                $('#videoviewdlg').modal('show');
                var play;
                startPlay(urls[0], 'viewcontent');
            }
        } catch (e) {
            console.log(e);
            return;
        }
    });

    $('#closeplayer').on('click', function () {
        $('#videoviewdlg').modal('hide');
        $('#viewcontent').html('');
    });
});

// 提交问卷
function submitQuestion() {
    var id = $('.art-questionnaire').attr('dataid');

    var data = [];
    for (var i = 0; i < $('.art-question').length; i++) {
        var ids = [];
        var otherbool = false;
        var othertext = '';
        var text = '';
        for (var j = 0; j < $($('.art-question')[i]).find('input:checked').length; j++) {
            if ($($('.art-question')[i]).find('input:checked')[j].value != 'other') {
                ids.push($($('.art-question')[i]).find('input:checked')[j].value);
            } else {
                othertext = $($($('.art-question')[i]).find('input:checked')[j])
                    .parent()
                    .next()
                    .val();
                if (othertext != '') otherbool = true;
            }
        }
        if ($($('.art-question')[i]).find('.art-question-input .art-question-text').length > 0)
            text = $($('.art-question')[i]).find('.art-question-input .art-question-text')[0].value;
        var answer = {
            question_id: $($('.art-question')[i]).attr('dataid'),
            text: text,
            selected_option_ids: ids,
            other_option_selected: otherbool,
            other_option_text: othertext
        };
        data.push(answer);
    }

    $.ajax({
        type: 'post',
        async: false,
        url: ROOT + '/a/questionnaire?id=' + id,
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data !== undefined && data.message !== undefined) {
                console.log(data);
                alert(data.message);
                return;
            } else {
                alert('问卷已提交');
                location.reload();
                return;
            }
        },
        error: function (data) {
            console.log(data);
        }
    });
}

// 提交投票
function submitVote() {
    var id = $('.art-votes').attr('dataid');

    var data = [];
    for (var i = 0; i < $('.art-vote').length; i++) {
        var topic = {
            id: $($('.art-vote')[i]).attr('dataid'),
            selected_option_id: $($('.art-vote')[i])
                .find('input:checked')
                .val()
        };
        data.push(topic);
    }

    $.ajax({
        type: 'post',
        async: false,
        url: ROOT + '/a/vote?id=' + id + '&day=' + dayLimit + '&total=' + totalLimit,
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data !== undefined && data.message !== undefined) {
                console.log(data);
                alert(data.message);
                return;
            } else {
                alert('投票已提交');
                location.reload();
                return;
            }
        },
        error: function (data) {
            console.log(data);
        }
    });
}

// 提交报名
function submitSignup() {
    var id = $('.art-signups').attr('dataid');

    var data = [];
    for (var i = 0; i < $('.art-signup').length; i++) {
        var text = '';
        var ids = [];
        var pic = '';
        var video = '';

        if ($($('.art-signup')[i]).find('.art-signup-text').length > 0) {
            text = $($('.art-signup')[i])
                .find('.art-signup-text')
                .children('input')
                .val();
        }
        if ($($('.art-signup')[i]).find('.art-signup-options').length > 0) {
            var children = $($('.art-signup')[i])
                .find('.art-signup-options')
                .find('input:checked');
            for (var j = 0; j < children.length; j++) {
                ids.push(children[j].value);
            }
        }
        if ($($('.art-signup')[i]).find('.art-signup-pic').length > 0) {
            pic = $($('.art-signup')[i])
                .find('.art-signup-pic')
                .children('input')
                .val();
        }
        if ($($('.art-signup')[i]).find('.art-signup-video').length > 0) {
            video = $($('.art-signup')[i])
                .find('.art-signup-video')
                .children('input')
                .val();
        }

        var field = {
            id: $($('.art-signup')[i]).attr('dataid'),
            text: text,
            selected_option_ids: ids,
            picture_path: pic,
            video_path: video
        };
        data.push(field);
    }

    $.ajax({
        type: 'post',
        async: false,
        url: ROOT + '/a/signup?id=' + id,
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data !== undefined && data.message !== undefined) {
                console.log(data);
                alert(data.message);
                return;
            } else {
                alert('报名已提交');
                location.reload();
                return;
            }
        },
        error: function (data) {
            console.log(data);
        }
    });
}

window.uploadid = function (id) {
    $('#uploadid').val(id);
};

window.uploads = function (file, type) {
    if (!file.files || !file.files[0]) {
        alert('读取文件失败');
        return;
    }
    var id = $('#uploadid').val();
    if (!id) return;
    var url = ROOT + '/config/pic_uploader';
    var uploader = '#pic_uploader';
    if (type == 1) {
        url = ROOT + '/config/video_uploader';
        uploader = '#video_uploader';
    }
    var reader = new FileReader();
    reader.onload = function (evt) {
        $.ajax({
            type: 'get',
            async: false,
            url: url,
            data: {},
            contentType: 'application/json',
            dataType: 'json',
            success: function (data) {
                if (data !== undefined && data.message !== undefined) {
                    alert('获取上传地址失败:' + data.message);
                    return;
                }
                showwait();
                $(uploader).ajaxSubmit({
                    url: data,
                    type: 'post',
                    success: function (rs) {
                        hidewait();
                        if (rs !== undefined) {
                            if (rs.isOK == 1) {
                                $('#signup' + id).text(file.files[0].name);
                                $('input[name=signup' + id + ']').val(rs.relativepath + rs.name);
                            } else if (rs.errMessage !== undefined) {
                                console.log(rs.errMessage);
                                alert('上传失败:' + rs.errMessage);
                            } else {
                                console.log(rs);
                                alert('上传失败');
                            }
                        }
                    },
                    error: function (data) {
                        hidewait();
                        console.log(data);
                        alert('上传异常');
                    }
                });
            },
            error: function (data) {
                if (data.message !== undefined) {
                    console.log(data.message);
                    alert('获取上传地址失败:' + data.message);
                } else {
                    console.log(data);
                    alert('获取上传地址失败');
                }
            }
        });
    };
    reader.readAsDataURL(file.files[0]);
};

function getNewest() {
    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/home/newest',
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }
            var newlist = '';
            for (var i = 0; i < data.length; i++) {
                var info = data[i];

                newlist += '<div class="newest-item">';
                newlist += '<div class="newest-item-img">';
                newlist += '<a href="' + info.url + '">';
                if (info.thumbnail_urls && info.thumbnail_urls.length > 0 && info.thumbnail_urls[0]) {
                    newlist += '<img src="' + info.thumbnail_urls[0] + '?w=242&h=152&s=3"/>';
                } else {
                    newlist += '<img src="' + ROOT + '/static/images/no-thumb.png"/>';
                }
                newlist += '</a>';
                newlist += '</div>';
                newlist += '<div class="newest-item-tilte">';
                newlist += '<a href="' + info.url + '">' + info.title + '</a>';
                newlist += '</div>';
                // newlist += '<div class="newest-item-time">' + info.publish_time + '</div>';
                newlist += '</div>';
            }

            $('.newest .newest-list').html(newlist);
        },
        error: function (data) {
            console.log(data);
        }
    });
}

function getCorrelates() {
    var id = $('.correlates-change').attr('dataid');
    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/home/correlates?id=' + id,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }
            var newlist = '';
            for (var i = 0; i < data.length; i++) {
                var info = data[i];

                newlist += '<div class="correlates-item">';
                newlist += '<div class="correlates-item-img">';
                newlist += '<a href="' + info.url + '">';
                if (info.thumbnail_urls && info.thumbnail_urls.length > 0 && info.thumbnail_urls[0]) {
                    newlist += '<img src="' + info.thumbnail_urls[0] + '?w=210&h=132&s=3"/>';
                } else {
                    newlist += '<img src="' + ROOT + '/static/images/no-thumb.png"/>';
                }
                newlist += '</a>';
                newlist += '</div>';
                newlist += '<div class="correlates-item-tilte">';
                newlist += '<a href="' + info.url + '">' + info.title + '</a>';
                newlist += '</div>';
                // newlist += '<div class="correlates-item-time">' + info.publish_time + '</div>';
                newlist += '</div>';
            }
            if (data.length % 3 != 0) {
                for (var i = data.length % 3; i < 3; i++) {
                    newlist += '<div class="correlates-item"></div>';
                }
            }

            $('.correlates .correlates-list').html(newlist);
        },
        error: function (data) {
            console.log(data);
        }
    });
}


/***/ }),
/* 14 */
/***/ (function(module, exports) {

﻿var code; // 在全局定义验证码

module.exports = {
    createCode: function () {
        // 产生验证码
        code = "";
        var codeLength = 4;//验证码的长度
        var checkCode = document.getElementById("code");
        var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R',
            'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z');//随机数
        for (var i = 0; i < codeLength; i++) {//循环操作
            var index = Math.floor(Math.random() * 36);//取得随机数的索引（0~35）
            code += random[index];//根据索引取得随机数加到code上
        }
        checkCode.value = code;//把code值赋给验证码
    },

    validate: function () {
        // 校验验证码
        var inputCode = document.getElementById("input").value.toUpperCase(); //取得输入的验证码并转化为大写
        if (inputCode.length <= 0) { //若输入的验证码长度为0
            alert("请输入验证码！"); //则弹出请输入验证码
            return false;
        }
        else if (inputCode != code) { //若输入的验证码与产生的验证码不一致时
            alert("验证码输入错误！"); //则弹出验证码输入错误
            createCode();//刷新验证码
            document.getElementById("input").value = "";//清空文本框
            return false;
        }
        else { //输入正确时
            return true;
        }
    }
};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

var callbackFun = null;
var sendData = null;

function islogin() {
    if ($('.top .top-user').data('info')) {
        return true;
    }

    return false;
}

// callback, 当点击确认后调用该函数
window.showReportDlg = function (type, data, callback) {
    if (!islogin()) {
        showLogin();
        return;
    }

    $('#dlg-report .check-rule').prop('checked', false);
    $('#dlg-report .report-content').val('');

    sendData = data;
    callbackFun = callback;

    $('#report-rules').html('');

    $.ajax({
        type: 'get',
        async: false,
        url: '/sharereport/rules/' + type,
        data: {},
        contentType: 'application/json',
        dataType: 'json',
        success: function (result) {
            if (result && result.length > 0) {
                for (var i = 0; i < result.length; i++) {
                    var tr = '<tr>' +
                        '    <td style="width: 48px;text-align: center;"><input type="checkbox" class="check-rule"></td>' +
                        '    <td class="rule-text" style="padding-left: 15px;">' + result[i] + '</td>' +
                        '</tr>';
                    $('#report-rules').append(tr);
                }
            }

            $('#dlg-report').modal('show');
        },
        error: function (data) {
            alert(data.responseText);
        }
    });
};

$(function () {
    $('.sure-dlg-report').click(function () {
        var text = [];
        for (var i = 0; i < $('#dlg-report .check-rule').length; i++) {
            if ($('#dlg-report .check-rule').eq(i).prop('checked')) {
                var str = $('#dlg-report .check-rule').eq(i).parent().parent().find('.rule-text').text();
                text.push(str);
            }
        }
        var str = $.trim($('#dlg-report .report-content').val());

        if (text.length == 0 && str.length == 0) {
            alert('请选择一个违规选项或者填写举报内容');
            return;
        }

        if (str.length > 0) {
            text.push(str);
        }
        sendData['content'] = text.join(';');
        var phone = $.trim($('#dlg-report .report-phone').val());
        if (phone.length == 0) {
            alert('请填写电话号码');
            return;
        }
        sendData['phone_number'] = phone;
        sendReport(sendData);
    });

    function sendReport(data) {
        $.ajax({
            type: 'post',
            async: false,
            url: '/shareusers/report',
            data: JSON.stringify(data),
            contentType: 'application/json',
            dataType: 'json',
            success: function (result) {
                $('#dlg-report').modal('hide');
                setTimeout(function () {
                    $('#dlg-reportresult').modal('show');
                }, 300);
                if (callbackFun) {
                    callbackFun(result);
                }
            },
            error: function (data) {
                alert(data.responseText);
            }
        });
    }
});

/***/ })
],[5]);


// WEBPACK FOOTER //
// js/artcf3b10.js